var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconoColumnaFiltroUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16.3 16.43",
    style: {
      enableBackground: "new 0 0 16.3 16.43"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-arrow-alt-circle-down",
    d: "M-0.07,8.22C-0.07,3.68,3.61,0,8.15,0s8.22,3.68,8.22,8.22 s-3.68,8.22-8.22,8.22C3.61,16.43-0.07,12.76-0.07,8.22C-0.07,8.22-0.07,8.22-0.07,8.22z M9.61,12.06V8.22h2.35 c0.22,0,0.4-0.18,0.4-0.4c0-0.1-0.04-0.2-0.11-0.27L8.43,3.75c-0.15-0.15-0.4-0.16-0.56,0c0,0,0,0,0,0L4.07,7.53 C3.91,7.69,3.92,7.94,4.07,8.1c0.07,0.07,0.17,0.11,0.27,0.11h2.34v3.85c0,0.22,0.18,0.4,0.4,0.4h2.12 C9.43,12.46,9.61,12.28,9.61,12.06z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoColumnaFiltroUp);
export default __webpack_public_path__ + "static/media/icono-columna-filtro-up.84e1affffa8f8d30fb1895332101e649.svg";
export { ForwardRef as ReactComponent };